import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { CalendarDays, Package, TrendingUp } from "lucide-react";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function AdminDashboard() {
  const { admin } = useAdminAuth();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ events: 0, products: 0, published: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await fetch(`${API_URL}/api/admin/events`, {
          headers: { Authorization: `Bearer ${admin.token}` },
        });
        const events = await res.json();
        const published = events.filter((e) => e.status === "published").length;

        let totalProducts = 0;
        for (const event of events) {
          const pRes = await fetch(
            `${API_URL}/api/admin/events/${event.id}/products`,
            { headers: { Authorization: `Bearer ${admin.token}` } }
          );
          const products = await pRes.json();
          totalProducts += products.length;
        }

        setStats({ events: events.length, products: totalProducts, published });
      } catch (err) {
        console.error("Failed to fetch stats:", err);
      }
    };
    fetchStats();
  }, [admin.token]);

  const cards = [
    {
      label: "Total Events",
      value: stats.events,
      icon: CalendarDays,
      color: "#D8C08F",
    },
    {
      label: "Published",
      value: stats.published,
      icon: TrendingUp,
      color: "#4ade80",
    },
    {
      label: "Total Products",
      value: stats.products,
      icon: Package,
      color: "#818cf8",
    },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <h1 className="text-white text-2xl font-sans font-semibold">
          Dashboard
        </h1>
        <p className="text-[#666] text-sm font-sans mt-1">
          Welcome back, {admin.name || "Admin"}
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
        {cards.map((card) => (
          <div
            key={card.label}
            className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-5"
            data-testid={`stat-card-${card.label.toLowerCase().replace(/\s/g, "-")}`}
          >
            <div className="flex items-center justify-between mb-3">
              <span className="text-[#888] text-xs font-sans uppercase tracking-wider">
                {card.label}
              </span>
              <card.icon size={18} style={{ color: card.color }} />
            </div>
            <p className="text-white text-3xl font-sans font-semibold">
              {card.value}
            </p>
          </div>
        ))}
      </div>

      <button
        onClick={() => navigate("/admin/events")}
        className="bg-[#D8C08F] text-black font-semibold px-6 py-3 rounded-lg text-sm font-sans hover:bg-[#c5ad7d] transition-colors"
        data-testid="manage-events-button"
      >
        Manage Events
      </button>
    </div>
  );
}
